// extracted by mini-css-extract-plugin
module.exports = {"shippingAddress":"shippingAddress__PbHKi","text":"text__3fxZE"};